import {Injectable, OnDestroy} from '@angular/core';
import {PdfPrintEvent} from '../../models';
import {PdfPrintDaoService} from './pdf-print-dao.service';
import {Subject, Subscription} from 'rxjs';
import {filter, switchMap, takeUntil, tap} from 'rxjs/operators';
import {USER_TOPIC} from '../../../../main';
import {R2CloudStompService} from '../../ws/r2-cloud-stomp.service';

@Injectable({
    providedIn: 'root'
})
export class PdfPrintService implements OnDestroy {
    private onDestroy$ = new Subject<void>();

    constructor(private stomp: R2CloudStompService, private pdfPrintDaoService: PdfPrintDaoService) {

    }
    stompTopic(): Subscription {
        return this.stomp.stompTopic<PdfPrintEvent>(`${USER_TOPIC}/pdf-print`).pipe(
            takeUntil(this.onDestroy$),
            filter(e => !!e && e.id != null && e.id > 0),
            tap((event: PdfPrintEvent) => console.log('PdfPrintEvent: ' + (event.id ?? ''))),
            switchMap((event: PdfPrintEvent) => this.pdfPrintDaoService.downloadPdfById(event.id ?? 0)),
            filter(Boolean),
        ).subscribe((pdfPrint) => {
            const objectUrl = URL.createObjectURL(pdfPrint);
            window.open(objectUrl, '_blank');
        });
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
}
